import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import {
    getAuth,
    onAuthStateChanged,
    signOut,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword
} from 'firebase/auth';
import {
    getFirestore,
    collection,
    onSnapshot,
    addDoc,
    doc,
    updateDoc,
    deleteDoc,
    serverTimestamp,
    arrayUnion,
    arrayRemove,
    getDoc,
    setDoc,
    runTransaction,
    writeBatch,
    // --- INÍCIO DA ALTERAÇÃO ---
    query,
    where,
    getDocs
    // --- FIM DA ALTERAÇÃO ---
} from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCskfLozI6EqU1ApigY7iIGFQHyCE4BRXU",
    authDomain: "v-flow-5ef74.firebaseapp.com",
    projectId: "v-flow-5ef74",
    storageBucket: "v-flow-5ef74.appspot.com",
    messagingSenderId: "380523283287",
    appId: "1:380523283287:web:3d6abe9bd3bb5fb4def412",
    measurementId: "G-5Z95LGCXE2"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export {
    app,
    auth,
    db,
    analytics,
    getAuth,
    onAuthStateChanged,
    signOut,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    getFirestore,
    collection,
    onSnapshot,
    addDoc,
    doc,
    updateDoc,
    deleteDoc,
    serverTimestamp,
    arrayUnion,
    arrayRemove,
    getDoc,
    setDoc,
    runTransaction,
    writeBatch,
    initializeApp,
    // --- INÍCIO DA ALTERAÇÃO ---
    query,
    where,
    getDocs
    // --- FIM DA ALTERAÇÃO ---
};